import { ChangeDetectionStrategy, Component, inject, input, Input } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { ApiService } from '@shared/services/api.service';
import { TemplateType } from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { Maybe } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipDirective],
  selector: 'aux-download-template-button',
  template: `
    <div
      class="btn--hyperlink flex justify-start {{ classList }}"
      [class.cursor-pointer]="!disabled()"
      [class.cursor-not-allowed]="disabled()"
      [class.opacity-50]="disabled()"
      [auxTooltip]="disabled() ? disabledTooltip() : ''"
      (click)="downloadFile()"
    >
      @if (showIcon) {
        <aux-icon name="Download" class="mr-1" />
      }

      <div class="self-end">{{ label }}</div>
    </div>
  `,
})
export class DownloadTemplateButtonComponent {
  apiService = inject(ApiService);
  overlayService = inject(OverlayService);

  disabled = input(false);
  disabledTooltip = input('');

  @Input() classList: string = '';
  @Input() fileName?: Maybe<string> = null;
  @Input({ required: true }) label!: string;
  @Input() showIcon = true;
  @Input() templatePayload?: Record<string, unknown> | string[];
  @Input({ required: true }) templateType!: TemplateType;
  @Input() vendorId: Maybe<string> = null;

  async downloadFile() {
    if (this.disabled()) {
      return;
    }

    const payloadString = this.templatePayload ? JSON.stringify(this.templatePayload) : undefined;

    const { data, success } = await this.apiService.getTemplatePath(
      this.vendorId ?? null,
      this.templateType,
      payloadString
    );

    if (!(success && data)) {
      this.overlayService.error(MessagesConstants.FILE.PROBLEM_DOWNLOADING_TEMPLATE);
    } else {
      await this.apiService.downloadFileFromPath(data.id, this.fileName ?? '');
    }
  }
}
